var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"mp-recipe-usage"},[_c('mp-meal-chip',{attrs:{"type":_vm.recipeUsage.meal}}),_c('div',{staticClass:"ml-1"},[_vm._v(_vm._s(_vm.recipeUsage.servings)+" "+_vm._s(_vm.recipeUsage.recipe.name))])],1)}
var staticRenderFns = []

export { render, staticRenderFns }